export default "__VITE_ASSET__BTHsET$f__"